import { render, staticRenderFns } from "./projektsearch.vue?vue&type=template&id=39511e52&scoped=true"
import script from "./projektsearch.vue?vue&type=script&lang=js"
export * from "./projektsearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39511e52",
  null
  
)

/* custom blocks */
import block0 from "./projektsearch.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports